import { render, staticRenderFns } from "./SendInviteDialog.vue?vue&type=template&id=70038857&scoped=true"
import script from "./SendInviteDialog.vue?vue&type=script&lang=js"
export * from "./SendInviteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70038857",
  null
  
)

export default component.exports